module.exports = __webpack_public_path__ + "static/media/air-freshener.b95cd5a4.svg";